import cn from "clsx";
import ConsentFormPara from "@/components/common/utils/consentFormPara";
const Consentbox = ({
  CN,
  attrbutes,
  textClass,
  disabled=false
}: {
  CN: string;
  attrbutes: any;
  textClass: string;
  disabled?: boolean;
}) => {
  return (
    <>
      <input
        {...attrbutes}
        className={cn(
          "outline-none text-primary-blue  align-middle  border-stone-500 appearance-none cursor-pointer checked:bg-primary-blue checked:border-transparent checked:outline-none checked:ring-2 checked:ring-primary-blue checked:ring-offset-2 checked:ring-offset-white",
          CN
        )}
        disabled={disabled}
      />

      <p className={cn("font-raleway font-normal text-[#686868]", textClass)}>
        <ConsentFormPara/>
      </p>
    </>
  );
};

export default Consentbox;
